import { Client, ActionEvent } from 'irc-framework';
import { IRC_EVENT, IRCMessageType, tabType } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import TabManager from '#/ui/tabManager';
import MessageHandler from '#/messageHandler';

export class ActionEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.ACTION, (event: ActionEvent) => {
            const { from_server, nick, ident, hostname, target, group, message, tags, time, account, batch } = event;

            if (target && target.startsWith('#')) {
                const channelTab = this.tM.getTab(tabType.CHANNEL, target);
                if (channelTab) {
                    this.mH.addMessage(channelTab, `* ${nick} ${message}`, IRCMessageType.ACTION, nick);
                } else {
                    this.mH.addMessage(this.tM.getStatusTab(), `* ${nick} ${message}`, IRCMessageType.ACTION, nick);
                }
            } else {
                if (nick) {
                    let queryTab = this.tM.getTab(tabType.QUERY, nick);
                    if (!queryTab) {
                        queryTab = this.tM.addTab(tabType.QUERY, nick);
                    }
                    this.mH.addMessage(queryTab, `* ${nick} ${message}`, IRCMessageType.ACTION, nick);
                } else {
                    this.mH.addMessage(this.tM.getStatusTab(), `* ${nick} ${message}`, IRCMessageType.ACTION, nick);
                }
            }
        });
    }
}